// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useMemo, useState } from "react";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { Table } from "../../molecules";
import { useGetMerchantGroupByTaxNumber } from "../../../hooks/merchant/useGetMerchantGroupByTaxNumber";
import { Loading, Button, StatusBarUser, MerchantBulkPortfolioModal } from "../../atoms";
import {
  GridActionsCellItem, GridRowId, GridRenderCellParams, GridPaginationModel,
} from "@mui/x-data-grid";
import { createStatusOperator } from "../../molecules/StatusFilterComponents";
import { useGetMerchantStatusList, useGetPosTypeList, useAddIks, useAuthorization } from "../../../hooks";
import dayjs from "dayjs";

function RenderStatus(props: GridRenderCellParams<any, string>) {
  const { value } = props;

  return <>{value && <StatusBarUser status={value} />}</>;
}

const MerchantGroupByTaxNumberDetail = ({ row, rawPosTypes, rawMerchantStatus, isPosTypeLoading, isMerchantStatusLoading }) => {
   const navigate = useNavigate();
   const { showDelete, showUpdate } = useAuthorization();
   const { mutate: addIks, isLoading: isAddingIks } = useAddIks();

    const posTypes = useMemo(() => {
      return rawPosTypes?.data?.map(
        (rawPosType: { key: string; value: string }) => {
          return {
            label: rawPosType.value,
            value: rawPosType.key,
          };
        }
      );
    }, [rawPosTypes?.data]);
  
    const merchantStatuses = useMemo(() => {
      return rawMerchantStatus?.data?.map(
        (merchantStat: { value: string; key: number }) => {
          return {
            label: merchantStat.key,
            value: `${merchantStat.value}`,
          };
        }
      );
    }, [rawMerchantStatus?.data]);

      const editRow = React.useCallback(
        (merchant: IMerchant) => () => {
          localStorage.removeItem("merchantData");
          navigate("/merchant-management/merchant-identification", {
            state: merchant,
          });
        },
        [navigate]
      );
 
  const detailColumns: GridColDef[] = useMemo(() => [
              {
                     field: "Aksiyonlar",
                     type: "actions",
                     width: 80,
                     getActions: (params) => [
                         <GridActionsCellItem
                         label="Düzenle"
                         onClick={editRow(params.row)}
                         showInMenu
                         />,
                     ],
                 },
    { field: "bkmIdNo", headerName: "BKM ID", width: 200 },
    {
      field: "posTypes",
      headerName: "Pos Tipi",
      width: 200,
      renderCell: (params) => {
        const posTypesForItem = posTypes?.filter(pt => params.row[pt.value])
          .map(pt => pt.label);
        return posTypesForItem?.join(", ");
      }
    }
    ,
    { field: "merchantId", headerName: "İşyeri No", width: 200 },
    { field: "merchantName", headerName: "İşyeri Adı", width: 200 },
    { field: "tradeName", headerName: "İşyeri Ticari Adı", width: 200 },
    {
      field: "parentMerchantName",
      headerName: "Bağlı Olduğu İşyeri Adı",
      width: 350,
    },
    {
      field: "userPortfolioName",
      headerName: "Satış Portföy",
      width: 150,
    },
    {
      field: "commissionProfileCode",
      headerName: "Çalışma Grubu",
      width: 200,
    },
    { field: "walletNo", headerName: "Cüzdan No.", width: 200 },
    { field: "taxNumber", headerName: "Vergi Kimlik No.", width: 200 },
    { field: "taxOfficeName", headerName: "Vergi Dairesi", width: 300 },
    { field: "mcc", headerName: "MCC", width: 100 },
    { field: "originalMcc", headerName: "Original MCC", width: 120 },
    {
      field: "aggreementDate",
      headerName: "Sözleşme Tarihi",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "";
        const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
        if (formattedDate === "Invalid Date") return "";
        return formattedDate;
      }
    },
    {
      field: "systemDate",
      headerName: "Oluşturma Tarihi",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "";
        const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
        if (formattedDate === "Invalid Date") return "";
        return formattedDate;
      }
    },
    {
      field: "openingDate",
      headerName: "İşyeri Açılış Tarihi",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "";
        const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
        if (formattedDate === "Invalid Date") return "";
        return formattedDate;
      }
    },
    {

      field: "closedDate",
      headerName: "İşyeri Kapanış Tarihi",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "";
        const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
        if (formattedDate === "Invalid Date") return "";
        return formattedDate;
      }
    },
    {
      field: "updateDate",
      headerName: "Güncelleme Tarihi",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "";
        const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
        if (formattedDate === "Invalid Date") return "";
        return formattedDate;
      }
    },
    { field: "updateUserName", headerName: "Güncelleyen Kullanıcı", width: 300 },
    { field: "officialFullName", headerName: "İşyeri Sahibin Adı", width: 300 },
    {
      field: "officialBirthDate",
      headerName: "İşyeri Sahibin Doğum T.",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "";
        const formattedDate = dayjs(params.value).format("DD.MM.YYYY HH:mm");
        if (formattedDate === "Invalid Date") return "";
        return formattedDate;
      }
    },
    { field: "webSite", headerName: "Web Sitesi", width: 300 },
    {
      field: "isInvoiceSendAsEmailEnabled", headerName: "CepPOS Ödeme Sonrası Email Gönderimi", width: 300, renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { field: "invoiceEmail", headerName: "Fatura Email Adresi", width: 300 },
    {
      field: "try",
      headerName: "TRY",
      width: 200,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    {
      field: "usd",
      headerName: "USD",
      width: 200,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    {
      field: "eur",
      headerName: "EUR",
      width: 200,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    {
      renderCell: RenderStatus,
      field: "status",
      headerName: "İşyeri Durumu",
      width: 150,
      filterOperators: [createStatusOperator(merchantStatuses)],

    },
    {
      renderCell: RenderStatus,
      field: "merchantStatusType",
      headerName: "İşyeri Durum Tipi",
      width: 150,
      filterOperators: [createStatusOperator(merchantStatuses)],

    },
    { field: "passiveReason", headerName: "Pasife Alma Nedeni", width: 230 },
    { field: "vbUye", headerName: "VB Üye", width: 180 },
    { field: "vbTerminal", headerName: "VB Terminal", width: 180 },
    {
      field: "vbiks", headerName: "IKS", width: 150,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { field: "hbUye", headerName: "HB Üye", width: 180 },
    { field: "hbTerminal", headerName: "HB Terminal", width: 180 },
    {
      field: "hbiks", headerName: "IKS", width: 150,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { field: "zbUye", headerName: "ZB Üye", width: 180 },
    { field: "zbTerminal", headerName: "ZB Terminal", width: 180 },
    {
      field: "zbiks", headerName: "IKS", width: 150,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { field: "isBUye", headerName: "İşB Üye", width: 180 },
    { field: "isBTerminal", headerName: "İşB Terminal", width: 180 },
    {
      field: "isBIKS", headerName: "IKS", width: 150,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { field: "dbUye", headerName: "DB Üye", width: 180 },
    { field: "dbTerminal", headerName: "DB Terminal", width: 180 },
    {
      field: "dbiks", headerName: "IKS", width: 150,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { field: "ktUye", headerName: "KT Üye", width: 180 },
    { field: "ktTerminal", headerName: "KT Terminal", width: 180 },
    {
      field: "ktiks", headerName: " IKS", width: 150,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
    { 
      field: "isApiPasswordSend", 
      headerName: "Şifre Gönderildi mi?", 
      width: 180,
      renderCell: (params) => {
        if (params.value === null || params.value === undefined) return " ";
        return params.value ? "Evet" : "Hayır";
      }
    },
  ], [editRow]);

  if (!row.merchants || row.merchants.length === 0) return <div>Kayıt bulunamadı</div>;
  return (
    <Stack sx={{ width: '100%', bgcolor: '#fafafa', p: 1 }}>
      <b>Aynı Vergi Kimlik Numarasına Sahip Şirketler:</b>
      <Table
        columns={detailColumns}
        rows={row.merchants.map((m, idx) => ({ ...m, id: m.merchantId || idx }))}
        hideFooter
        density="compact"
      />
    </Stack>
  );
};

export const MerchantTaxNumberList = () => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: 25 });
  const { data, isLoading, isError } = useGetMerchantGroupByTaxNumber({
    page: paginationModel.page + 1,
    size: paginationModel.pageSize,
    orderBy: "TaxNumber",
    orderByDesc: false,
  });

  const { data: rawPosTypes, isLoading: isPosTypeLoading } = useGetPosTypeList({});
  const { data: rawMerchantStatus, isLoading: isMerchantStatusLoading } = useGetMerchantStatusList({});

  const mainColumns: GridColDef[] = useMemo(() => [
    { field: "taxNumber", headerName: "Vergi Numarası", width: 250 },
    { field: "totalCount", headerName: "Şirket Sayısı", width: 200 },
  ], []);

  const rows = data?.data?.result?.map((item, idx) => ({
    id: idx,
    taxNumber: item.taxNumber,
    totalCount: item.totalCount,
    merchants: item.merchants || [],
    isRowExpanable: Array.isArray(item.merchants) && item.merchants.length > 0,
  })) || [];

  const isRowExpandable = (row) => Array.isArray(row.merchants) && row.merchants.length > 0;

  return (
    <Stack flex={1} p={2}>
      <Table
        isMasterDetailActive={true}
        isRowExpandable={isRowExpandable}
        masterDetailContent={({ row }) => (
          <MerchantGroupByTaxNumberDetail
            row={row}
            rawPosTypes={rawPosTypes}
            rawMerchantStatus={rawMerchantStatus}
            isPosTypeLoading={isPosTypeLoading}
            isMerchantStatusLoading={isMerchantStatusLoading}
          />
        )}
        columnVisibilityConfigKey="merchantGroupByTaxNumberTableColumnVisibilityKey"
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        paginationMode="server"
        rowCount={data?.data?.totalItems || 0}
        sx={{ width: isDesktop ? 600 : window.innerWidth - 50 }}
        rows={rows}
        columns={mainColumns}
        loading={isLoading}
        error={isError}
      />
    </Stack>
  );
};
